import React from 'react';
import {
	VerticalTimeline,
	VerticalTimelineElement,
} from 'react-vertical-timeline-component';

// Assets
import { ReactComponent as WorkIcon } from '../assets/icons/work.svg';
import { ReactComponent as SchoolIcon } from '../assets/icons/school.svg';

// Style
import './Timeline.scss';
import 'react-vertical-timeline-component/style.min.css';

const Timeline = ({ elements }) => {
	const workIconStyles = { background: '#dd0426' };
	const schoolIconStyles = { background: '#272f42' };

	return (
		<VerticalTimeline lineColor="#dd0426">
			{elements.map(element => {
				const isWorkIcon = element.icon === 'work';
				const showButton =
					element.buttonText !== undefined &&
					element.buttonText !== null &&
					element.buttonText !== '';
				return (
					<VerticalTimelineElement
						key={element.id}
						date={element.date}
						iconStyle={
							isWorkIcon ? workIconStyles : schoolIconStyles
						}
						icon={isWorkIcon ? <WorkIcon /> : <SchoolIcon />}>
						<h3 className="vertical-timeline-element-title">
							{element.title}
						</h3>
						<h5 className="vertical-timeline-element-subtitle fw-normal">
							{element.location}
						</h5>
						<p id="description" className="fw-light">
							{element.description}
						</p>
						{showButton && (
							<a
								className={`button ${
									isWorkIcon ? 'btn-danger' : 'btn-primary'
								}`}
								href={element.link ? element.link : '/'}>
								{element.buttonText}
							</a>
						)}
					</VerticalTimelineElement>
				);
			})}
		</VerticalTimeline>
	);
};

export default Timeline;
